const pdfStyle = `
@page { 
  @bottom-right-corner { 
    content: 'Page ' counter(page); 
    transform: rotate(-90deg) translateX(60%); 
  } 
  @top-center { 
    content: element(logoRun); 
  }
  @bottom-left-corner { 
    content: element(footerRun); 
  } 
} 
.running-logo { 
  position: running(logoRun); 
  width: 175px; 
  height: auto; 
  margin: auto 
} 
.running-footer { 
  position: running(footerRun); 
  width: 100%; 
} 
section[data-type='cover'] { 
  page: cover; 
} 
@page cover {
  display: block; 
  page-break-after: always;
  @top-center {
    content: none;
  } 
  @bottom-right-corner {
    content: none;
  }
  margin: 15mm;
}
section[data-type='last-page'] { 
  page: last-page; 
}
@page last-page { 
  @top-center { content: none; } 
  @bottom-left-corner { content: none; } 
  @bottom-right-corner {content: none;} 
  margin: 15mm; 
} 
section[data-type='toc'], section[data-type='contact-info'] { 
  page-break-before: always 
}
#list-toc-generated .toc-element a::after{
  content: ' p. ' target-counter(attr(href), page); 
  float: right;
} 
#list-toc-generated { 
  font-size: 12.95px; 
  overflow-x: hidden; 
} 
#list-toc-generated{ 
  list-style: none;
}
#list-toc-generated .toc-element-level-1{
  margin-top: 5px;
  font-weight: bold;
}
#list-toc-generated .toc-element-level-2{
  margin-left: 25px;
}
#list-toc-generated {
  counter-reset: counterTocLevel1;
}
#list-toc-generated .toc-element-level-1 {
  counter-increment: counterTocLevel1;
  counter-reset: counterTocLevel2;
}
.toc-element-level-1::before{
  content: counter(counterTocLevel1) ". ";
  padding-right: 5px;
}
#list-toc-generated .toc-element-level-2{
  counter-increment: counterTocLevel2;
}
#list-toc-generated .toc-element-level-2::before{
  content: counter(counterTocLevel1) ". " counter(counterTocLevel2) ". ";
  padding-right: 5px;
}
#list-toc-generated{
  overflow-x: hidden;
}
#list-toc-generated .toc-element::after{
  content: "..............................................................................................................................";
  float: left;
  width: 0;
  padding-left: 5px;
  letter-spacing: 2px;
}
#list-toc-generated .toc-element{
  display: flex;
  position: relative;
  page-break-inside: avoid;
}
#list-toc-generated .toc-element a::after{
  position: absolute;
  right: 0;
  top: 0;
  background-color: white;
  padding-left: 6px;
}
#list-toc-generated .toc-element a{
  right: 0;
}
section.content-section { 
  page-break-before: always; 
} 
h1, h2, h3 { 
  page-break-after: avoid; 
} 
.content-subsection img, .content-sub-subsection img { 
  page-break-before: avoid;
}
.break-after {
  page-break-after: always;
}
`

export default pdfStyle;